export default {
    app: {
        name: 'Forecaster',
        title: 'Forecaster',
        loading: 'Loading...',
        error: 'An error occurred.',
        saved: 'Saved',
        save: 'Save',
    },
    home: {
        welcome: 'Welcome to Forecaster!',
        upcomingRain: 'Upcoming Rain',
        searchLocation: 'Search Location',
        loadingData: 'Loading weather data...',
        findingLocation: 'Finding your location...',
        geolocationError: 'Failed to get current location. Please enable location services or search for a location.',
        offlineError: 'You appear to be offline. Please check your internet connection.',
        serverError: 'There was a problem connecting to our server. Please try again later.',
        forecastUnavailableError: 'A current forecast is not available for this location. Please try again later.',
        currentLocation: 'Current Location',
        fetchError: 'Failed to load weather data. Please try again later.',
        retry: 'Retry',
        byMetNo: 'Powered by YR.no',
        byMeteoFrance: 'Powered by Météo-France',
        byAppleWeather: 'Powered by {appleIcon} Weather',
        byGoogleWeather: 'Powered by Google Weather',
        validUntil: 'Valid until {time}',
        loadedAt: 'Loaded at {time}',
        currently: 'Currently',
        thisWeek: 'This Week',
        today: 'Today',
        tomorrow: 'Tomorrow',
        geolocationErrorGeneric: 'Something went wrong while trying to detect your location.',
        geolocationPermissionDenied: 'Location access was denied. Please allow location sharing in your browser settings to continue.',
        geolocationPositionUnavailable: 'We couldn’t determine your location. This may be due to poor signal or disabled location services.',
        geolocationTimeout: 'It’s taking too long to find your location. Please try again or check your connection.',
        geolocationUnsupported: 'Location is unavailable in this browser or context. Please use HTTPS or search for a location.',
        geolocationPromptRequired: 'Tap Retry to allow location access and continue.',
        providerError: 'Could not load data from {providerName}. They may be experiencing issues. Please try again later.'
    },
    units: {
        precipitation: {
            mm: '{value} mm',
            in: '{value} in',
        },
    },
    drawer: {
        currentLocation: 'Current location',
        starredLocations: 'Starred locations',
        starToSave: 'Star a place to save it here.',
        settings: 'Settings',
        colorGuide: 'Color guide',
        feedback: 'Feedback',
        helpTranslate: 'Help translate',
    },
    colorGuide: {
        title: 'Color guide',
        clear: 'Clear',
        clear_explanation: 'No precipitation is forecast and less than 25% of the sky will be covered by cloud.',
        partly_cloudy: 'Partly Cloudy',
        partly_cloudy_explanation: 'Between 25% and 75% of the sky will be covered by cloud. No precipitation is forecast.',
        cloudy: 'Cloudy',
        cloudy_explanation: 'More than 75% of the sky will be covered by cloud. No precipitation is forecast.',
        scattered_rain: 'Scattered Rain',
        scattered_rain_explanation: 'There will be rain in the area, but we aren’t sure if it will hit your exact location.',
        rain: 'Rain',
        rain_explanation: 'There is a strong chance of rain.',
        scattered_snow: 'Scattered Snow',
        scattered_snow_explanation: 'There will be snow in the area, but we aren’t sure if it will hit your exact location.',
        snow: 'Snow',
        snow_explanation: 'There is a strong chance of snow.',
    },
    settings: {
        title: 'Settings',
        wind_speed_units_default: 'mph',
        temperature_units_default: 'celsius',
        night_mode_default: 'system',
        units: 'Units',
        temperature_units: 'Temperature',
        wind_speed_units: 'Wind Speed',
        precipitation_units: 'Precipitation',
        forecast: 'Forecast',
        hide_early_morning: 'Hide early morning hours',
        hide_early_morning_explanation: 'Show the weather from 5am onwards rather than the full 24 hours',
        appearance: 'Appearance',
        theme: 'Theme',
        show_minMax: 'Show Min/Max Temperatures',
        show_minMax_summary: 'Display daily min/max temperatures along side the rain & cloud info',
        auto_expand_today: 'Auto-expand today\'s forecast',
        about: 'About',
        privacy_policy: 'Privacy Policy',
        terms_of_service: 'Terms of Service',
        provider: 'Provider',
        data_source: 'Data Source',
        language: 'Language',
        unit_selection: {
            celsius: 'Celsius',
            fahrenheit: 'Fahrenheit',
        },
        wind_speed_unit_selection: {
            mph: 'mph',
            knots: 'knots',
            kmh: 'km/h',
            ms: 'm/s',
            beaufort: 'Beaufort Scale',
        },
        precipitation_unit_selection: {
            mm: 'mm',
            inches: 'inches',
        },
        night_mode_options: {
            system: 'System default',
            light: 'Light',
            dark: 'Dark',
        },
        data_source_options: {
            auto: 'Automatic',
            metno: 'YR.no',
            meteofrance: 'MeteoFrance',
            appleweather: 'Apple Weather',
            googleweather: 'Google Weather',
        },
        language_selection: {
            en: 'English',
            de: 'Deutsch',
            es: 'Español',
            fr: 'Français',
            it: 'Italian',
        }
    },
    provider_modal: {
        title: 'Choose Your Weather Source',
        close_modal: 'Close provider selection',
        cancel: 'Cancel',
        save: 'Save',
        metno_desc: 'Trusted global forecasts from the Norwegian Meteorological Institute.',
        meteofrance_desc: 'Detailed, high-resolution forecasts tailored for France.',
        appleweather_desc: 'Accurate, high-resolution data from Apple Weather.',
        googleweather_desc: 'High-quality global forecasts from Google.',
        auto_desc: 'Let the app pick the best source for your location automatically.',
    },
    searchModal: {
        searchForLocation: 'Search for a location...',
        placeholder: 'Search for a place',
        closeModal: 'Close search modal',
        googleMapsError: 'Error loading Google Maps Places library:',
        googleMapsNotLoaded: 'Google Maps JavaScript API library not loaded.',
        placesLibraryError: 'Places library not fully loaded or session token missing.',
        fetchPredictionsError: 'Error fetching place predictions:',
        fetchDetailsError: 'Error fetching place details:',
        noInput: 'Start typing to search for locations.',
        noResults: 'No results found.',
        noRecentlyViewed: 'No recently viewed.',
        searchUnavailable: 'Search is unavailable because Google services are blocked by this browser or your configuration.',
        searching: 'Searching...',
        recentlyViewed: 'Recently Viewed',
    },
    minutelyTimeline: {
        now: 'Now',
        minutes: '{minutes}',
        minutesWithUnit: '{minutes} min',
    },
    upcomingRain: {
        maxIntensity: 'Heavy',
        midIntensity: 'Moderate',
        minIntensity: 'Light',
    },
    weeklyForecast: {
        rainCloud: 'Rain & Cloud',
        temperature: 'Temperature',
        wind: 'Wind',
    },
    feedback: {
        title: 'Feedback is welcome',
        message: 'Your feedback helps me improve Forecaster. Please let me know what you think!',
        featureIdeas: 'Got a feature idea? Please share it.',
        contactUs: 'You can reach me at',
        send: 'Send Feedback',
    },
    forecastInfo: {
        details: 'Forecast Information',
        explanation: 'Weather forecasts are updated periodically by our providers.',
        computed: 'Generated by provider',
        expires: 'New forecast expected',
        loaded: 'Downloaded',
        close: 'Close',
    }
};
